import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingCond } from '../constants/constants';

@Pipe({ name: 'colorMappingCond' })
export class ColorMappingCondPipe implements PipeTransform {
  transform(value: number, detailsToShow?: boolean) {
    return colorMappingCond(value, detailsToShow);
  }
}
